<div class="activity-filters">
  <div class="activity-filter-controls">
    @for (key of [pickerKey()]; track key) {
      <tidy-header-select
        class="activity-agent-picker"
        [items]="agents()"
        [placeholder]="'Agent'"
        [icon]="'assets/svg/filter-outline.svg'"
        (optionChange)="pickAgent($event)" />
    }
    <ng-content select="[activity-date-filter]" />
  </div>
  @if (filterName()) {
    <div class="activity-filter-chips">
      <ion-chip class="filter-chip">
        <ion-label>{{ filterName() }}</ion-label>
        <ion-icon name="close-circle" [title]="'Show all agents' | translate" (click)="clearFilter.emit()" />
      </ion-chip>
    </div>
  }
  @if (!loading() && summary()) {
    <div class="activity-summary">
      <span>{{ summary().total }} {{ (summary().total === 1 ? 'run' : 'runs') | translate }}</span>
      @if (summary().failed > 0) {
        <span class="activity-summary-separator">·</span>
        <span class="activity-summary-failed">{{ summary().failed }} {{ 'failed' | translate }}</span>
      }
    </div>
  }
</div>
<div class="activity-list">
  @if (loading()) {
    @for (i of skeletonRows; track i) {
      <div class="activity-run activity-run-skeleton">
        <ion-skeleton-text [animated]="true" class="sk-line sk-agent" />
        <ion-skeleton-text [animated]="true" class="sk-line sk-flow" />
        <ion-skeleton-text [animated]="true" class="sk-line sk-time" />
      </div>
    }
  } @else {
    @for (row of rows(); track row.id) {
      <div class="activity-run" (click)="openRun.emit(row.run)">
        <div class="activity-run-head">
          <div class="activity-run-title">
            <ion-icon [name]="row.icon" class="activity-run-status-icon" [ngClass]="row.status" [title]="row.statusLabel | translate" />
            <span class="activity-run-agent">{{ row.agentName }}</span>
            <span class="activity-run-time" [title]="row.time | parseDateTime:'MMM d, yyyy h:mma':'local' | translate">
              @if (row.dayLabel) {
                {{ row.dayLabel | translate }}, {{ row.time | parseDateTime:'h:mma':'local' }}
              } @else {
                {{ row.time | parseDateTime:'MMM d, h:mma':'local' }}
              }
            </span>
          </div>
          <tidy-image [src]="'assets/img/chevron-right.svg'" class="activity-chevron" />
        </div>
        @if (row.triggerName || row.steps.length) {
          <div class="activity-run-flow">
            @if (row.triggerName) {
              <span class="activity-flow-chip trigger">
                @if (row.triggerIconUrl) {
                  <tidy-image [src]="row.triggerIconUrl" class="activity-flow-icon" />
                }
                <span class="activity-flow-name">{{ row.triggerName }}</span>
              </span>
            }
            @for (step of row.steps; track $index) {
              @if (row.triggerName || !$first) {
                <ion-icon name="arrow-forward" class="activity-flow-arrow" />
              }
              <span class="activity-flow-chip action" [class.failed]="step.failed">
                @if (step.iconUrl) {
                  <tidy-image [src]="step.iconUrl" class="activity-flow-icon" />
                }
                <span class="activity-flow-name">{{ step.name }}</span>
              </span>
            }
          </div>
        }
        @for (step of row.steps; track $index) {
          @if (step.error) {
            <div class="activity-run-error">{{ step.error }}</div>
          }
        }
        @if (row.detailLabel) {
          <div class="activity-run-detail" [class.failed]="row.status === 'failed'">{{ row.detailLabel | translate }}</div>
        }
      </div>
    }
    @if (rows().length === 0) {
      <div class="activity-empty">
        <tidy-text [helper]="'No agent runs yet.'" />
      </div>
    }
    @if (canLoadMore()) {
      <div class="activity-load-more">
        @if (loadingMore()) {
          <tidy-text [helper]="'Loading...'" />
        } @else {
          <tidy-text [actionBody]="'Load more'" (action)="loadMore.emit()" class="link" />
        }
      </div>
    }
  }
</div>
